export default __webpack_public_path__ + "HenrySans-Regular.24acc7dbd23d5420745c5f0586252ddc.woff2";